import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import BtechMSDualdegree_curriculumEle from './BtechMSDualdegree_curriculumEle'


function Main() {
    return (
      <>
          <Header/>
        <Breadcrumb title="Home" subtitle="Curriculum"/>
        <BtechMSDualdegree_curriculumEle />
        
      </>
    )
  }
  
  export default Main